
import { defineStore } from "pinia"
import { ref } from 'vue'
import type{ AppError} from '@/types/appErrorDef'

export const useAppErrorStore = defineStore('appError', () => {
  const sleep = (millis: number) => new Promise(resolve => setTimeout(resolve, millis));
  const appError = ref<AppError | null>(null)
  const updateAppError = async (newAppError: AppError | null) => {
    appError.value = newAppError
  }
  const resetAppError = async () => {
    const curAppError = structuredClone(appError.value);
    await sleep(1000)
    appError.value = null;
    appError.value = curAppError;
  }

  return {
    updateAppError,
    resetAppError,
    appError,
  }
})
